module.exports = __webpack_public_path__ + "img/g2.ffa8baa3.png";